import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  background-color: ${props => props.theme.background};
`

/** @component */
export default Wrapper
